import { useCallback } from "react";
import { useIntl } from "react-intl";
import { useMutation, useQueryClient } from "react-query";
import { enqueueSnackbar } from "notistack";
import { Box, Typography } from "@mui/material";
import AddIcon from "@mui/icons-material/Add";

import MailsFormTemplate from "./MailsFormTemplate";
import { FormDetailsType } from "../../../Configuration/interfaces";
import { basicCreate } from "../../../Configuration/utils";
import AppButton from "../../../components/AppButton";

const MailsCreation = () => {
  const intl = useIntl();
  const queryClient = useQueryClient();

  const createMailMutation = useMutation(
    ({
      url,
      data,
      options,
    }: {
      url: string;
      data: any;
      options: FormDetailsType;
    }) => basicCreate(url, data, options),
    {
      onSuccess: () => {
        queryClient.invalidateQueries("notifications-mails-list");
        enqueueSnackbar(intl.formatMessage({ id: "OPERATION_SUCCESS" }), {
          variant: "success",
        });
      },
      onError: () => {
        enqueueSnackbar(intl.formatMessage({ id: "OPERATION_FAILED" }), {
          variant: "error",
        });
      },
    }
  );

  const handleSubmit = useCallback(
    ({
      url,
      data,
      options,
    }: {
      url: string;
      data: any;
      options: FormDetailsType;
    }) => {
      createMailMutation.mutate({ url, data, options });
    },
    [createMailMutation]
  );

  return (
    <Box
      sx={(theme) => ({
        border: `1px solid ${theme.vars.palette.border.inputOutlined}`,
        borderRadius: "6px",
        padding: 1,
        backgroundColor: "background.default",
      })}
    >
      <Box
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          marginBottom: 2,
        }}
      >
        <Typography>
          {intl.formatMessage({ id: "NOTIFICATION_CREATE_MAILS" })}
        </Typography>
        <AppButton
          startIcon={<AddIcon />}
          loading={createMailMutation.isLoading}
          type="submit"
          form="notification-mails-form"
        >
          {intl.formatMessage({ id: "ADD" })}
        </AppButton>
      </Box>
      <MailsFormTemplate onSubmit={handleSubmit} />
    </Box>
  );
};

export default MailsCreation;
